import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  private http = inject(HttpClient);

  private get token(): string {
    return sessionStorage.getItem('token') as string;
  }

  public uploadFile(uploadFiles: any) {
    const formData = new FormData();
    for (const file of uploadFiles) {
      formData.append('file', file);
    }
    let httpOptions = {};

    if (this.token) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: this.token,
        }),
        responseType: 'text' as 'json'
      };
    } else {
      httpOptions = {
        responseType: 'text' as 'json'
      };
    }

    return this.http.post(`${environment.api}/reader-service/upload`, formData, httpOptions);
  }

  public getFile(file: string, manuallyEnteredBaseUrl?: string): Observable<Blob> {
    return this.http.get(`${manuallyEnteredBaseUrl ? manuallyEnteredBaseUrl : environment.api}/reader-service/download`,
      {
        headers: new HttpHeaders({
          Authorization: this.token,
          'Content-Type': 'application/json',
        }),
        responseType: 'blob',
        params: {
          filePath: file,
        },
      });
  }

  public getFileWithAuthorization(file: string, manuallyEnteredBaseUrl?: string): Observable<Blob> {
    return this.http.get(`${manuallyEnteredBaseUrl ? manuallyEnteredBaseUrl : environment.api}/reader-service/download-files`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        responseType: 'blob',
        params: {
          filePath: file,
        },
      });
  }

  checkForImageFile(filePath: string): boolean {
    const base64String = (filePath);
    const binaryString = atob(base64String);
    const binaryArray = Uint8Array.from(binaryString, (char) => char.charCodeAt(0));
    const utf8String = new TextDecoder('utf-8').decode(binaryArray).split('/');
    const fileName = utf8String.pop() as string;
    const file = fileName.split('.');
    const fileType = file.at(-1);
    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      return true;
    }
    return false;
  }

  downloadFile(filePath: string) {
    this.getFile(filePath).subscribe({
      next: (arquivo: Blob) => {
        const url = window.URL.createObjectURL(arquivo);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.getFileName(filePath);
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      error: e => { }
    });
  }

  getFileName(filePath: string): string {
    const fileName = atob(filePath).split('/');
    if (fileName) {
      return fileName.pop() as string;
    }
    return '-';
  }

  public uploadPublicFile(uploadPublicFiles: any) {
    const formData = new FormData();
    for (let i = 0; i < uploadPublicFiles.length; i++) {
      formData.append('file', uploadPublicFiles[i]);
    }

    return this.http.post(`${environment.api}/reader-service/public/upload`, formData, {
      responseType: 'text',
    });
  }

  public downloadPublicFile(file: string): Observable<Blob> {
    return this.http.get(`${environment.api}/reader-service/public/download`,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        responseType: 'blob',
        params: {
          filePath: file,
        },
      });
  }
}
